window.addEventListener('lbVdWidgetRendred', (event) => {
  if (event.detail && event.detail.widgetType === 'widget#vdtable') {
    const rates = document.querySelectorAll('.lb-vd-table-body-text .money');

    if (rates.length == 0) {
      console.log('No rates found to update');
      return;
    }

    rates.forEach((rate) => {
      if (rate.classList.contains('price--vat-excluded')) {
        console.log('Rates have already been updated to have VAT and non-VAT versions');
        return;
      }
      rate.classList.add('price--vat-excluded');

      const priceString = rate.textContent.trim();
      // Extract the currency symbol and numeric value
      const currencySymbol = priceString.match(/[^0-9.,]+/)?.[0] || '';
      const numericString = priceString.replace(/[^0-9.,]/g, '').replace(',', '');
      const numericValue = parseFloat(numericString);

      if (isNaN(numericValue)) {
        console.error(`Invalid price format, can't adjust quantity break rates for VAT`);
        return;
      }
      const vatMultipler = 1 + Number(document.documentElement.dataset.vatPercentage) / 100;

      // Add VAT
      const discountedValue = numericValue * vatMultipler;

      // Format the number (keeping decimals if original had them)
      const hasDecimal = priceString.includes('.');
      const formattedValue = hasDecimal
        ? discountedValue.toFixed(2)
        : Math.round(discountedValue).toString();

      // Add thousand separators if original had them
      let result;
      if (priceString.includes(',')) {
        result = discountedValue.toLocaleString('en-US', {
          maximumFractionDigits: hasDecimal ? 2 : 0,
        });
      } else {
        result = formattedValue;
      }

      const finalPriceString = currencySymbol + result;
      rate.insertAdjacentHTML('afterend', `<span class="price--vat-included">${finalPriceString}</span>`);
    });
  }
});